import type { PIIString } from '@trello/privacy';

import { MemberActivityPage } from 'app/src/components/MembersPages/MemberActivityPage';
import { controllerEvents } from './controllerEvents';
import { renderTopLevelComponent } from './renderTopLevelComponent';

export const memberActivityPageController = async ({
  username,
}: {
  username: PIIString;
}) => {
  controllerEvents.trigger('clearPreviousView');
  controllerEvents.trigger('setViewType', 'MembersView');
  renderTopLevelComponent(<MemberActivityPage username={username} />);
};
